import { useState } from "react";

import QuickTable from "components/Meta/QuickTable";
import date from "date-and-time";
import dates from "tools/dates";
import SearchWidget from "components/Tools/SearchWidget";

let last14 = date.addHours(new Date(), -14);
last14 = dates.fmtDatetime2Tryton(last14);

const FILTER = {
  today: [
    // ["create_uid", "=", session.user],
    ["create_date", ">=", last14],
  ],
  active: [
    ["state", "=", "draft"],
    ["create_date", ">=", last14],
  ],
  reservation: [
    ["state", "in", ["draft", "quotation"]],
    ["kind", "=", "reservation"],
  ],
};

const colorMap = {
  today: "bg-purple-100 text-purple-600",
  active: "bg-yellow-100 text-yellow-600",
  reservation: "bg-blue-100 text-blue-600",
};

function ListView({ defaultShop, onChangeView, ctxView }) {
  const [filter, setFilter] = useState("active");
  const defaultDomain = [
    ["shop", "=", defaultShop],
    ["transfer_to", "=", null],
  ].concat(FILTER[filter]);
  const [domain, setDomain] = useState(defaultDomain);

  function handleFilter(key) {
    let domain = null;
    if (Object.keys(FILTER).includes(key)) {
      domain = [
        ["shop", "=", defaultShop],
        ["transfer_to", "=", null],
      ].concat(FILTER[key]);
    } else {
      domain = FILTER.active.concat(key);
    }

    setDomain(domain);
    setFilter(key);
  }

  return (
    <>
      <div className="flex flex-wrap gap-3 justify-start my-4">
        {Object.entries(FILTER).map(([key]) => (
          <button
            key={key}
            onClick={() => handleFilter(key)}
            className={`flex items-center justify-between w-36 md:min-w-[180px] px-1 md:px-4 py-2 h-12 rounded-xl shadow-sm
            ${colorMap[key] || "bg-gray-100 text-gray-600"} 
            hover:opacity-90 transition
            ${filter === key ? "ring-2 ring-offset-2 ring-gray-400" : ""}
          `}
          >
            <span className="font-semibold capitalize">{key}</span>
          </button>
        ))}
        <div className="basis-lg">
          <SearchWidget handleFilter={handleFilter} ctxView={ctxView} />
        </div>
      </div>
      <div className="">
        <QuickTable
          onChangeView={onChangeView}
          ctxView={ctxView}
          domain={domain}
        />
      </div>
    </>
  );
}

export default ListView;
